import React from "react";
import { IAccount, ITotalByMonth } from "../../../common/accounts2";
import { empty, kopecks2rubStr } from "../../../common/functions";
import { pathPrefix } from "../../../common/config/vars";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";
import { Link } from "react-router-dom";
import { $SiteColors } from "../../../common/config/company-atts";

interface ITotalByMonthBlock {
  account: IAccount;
  setLookButtonIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
  setTotal: React.Dispatch<React.SetStateAction<ITotalByMonth | undefined>>;
}

//отрисовывает последнее начисление по текущему аккаунту
export const TotalByMonthBlock = ({
  account,
  setLookButtonIsClicked,
  setTotal
}: ITotalByMonthBlock) => {
  let totalsByMonth = account.totalByMonth; //список начислений
  const lastTotal = empty(totalsByMonth) ? undefined : totalsByMonth[0]; //последнее начисление

  // Пробрасываем начисление наверх в эффекте, а не в рендере
  // (иначе React ругается на setState во время рендера другого компонента).
  React.useEffect(() => {
    setTotal(lastTotal)
  }, [account, setTotal]) // eslint-disable-line react-hooks/exhaustive-deps

  if (empty(totalsByMonth)) {
    return (


<div className="payment__container">
<h4 className="payment__title">Начисления не обнаружены</h4>
     
<div className="payment__numbers-button">
 
  <div className="payment__button__wrapper">
   
    {getCustomUserAgent() === getCustomUserAgentASB() ?
      <button
        type="button"
        className="payment__button"
        style={{ backgroundColor: $SiteColors.getState().backBtnPayDebt }}
        // onClick={() => setLookButtonIsClicked(true)}
      >
        <Link to={pathPrefix+"/acts"}>Получить акт сверки</Link>
      </button> : null}
  </div>
</div>
</div>
    );
  }
  let total = totalsByMonth[0]; //последнее начисление
  let title = "Начислено " + "за " + total.periodName;
  /*if (!empty(total.billDate)) {
    let billDate = total.billDate;
    let d: Date = new Date(billDate);
    if (!isNaN(d.getTime()))
      title +=
        "на " +
        d.toLocaleString("ru", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
  } else if (!empty(total.periodName)) title += "на " + total.periodName;*/

  return (
    <div className="payment__container">
      <h4 className="payment__title">{title}</h4>
      <div className="payment__numbers-button">
        <p className="payment__text">{kopecks2rubStr(total.monthAmount)}</p>
        <div className="payment__button__wrapper">
          <button
            type="button"
            className="payment__button"
            style={{ backgroundColor: $SiteColors.getState().backBtnTotalByMonth }}
            onClick={() => setLookButtonIsClicked(true)}
          >
            <a href="#last-charge" >Посмотреть</a>
          </button>
          {getCustomUserAgent() === getCustomUserAgentASB() ?
            <button
              type="button"
              className="payment__button"
              style={{ backgroundColor: $SiteColors.getState().backBtnTotalByMonth }}
              // onClick={() => setLookButtonIsClicked(true)}
            >
              <Link to={pathPrefix+"/acts"}>Получить акт сверки</Link>
            </button> : null}
        </div>
      </div>
    </div>
  );
};
